export class StorageClass {
  Name: string = '';

  Provisioner: string = '';

  ReclaimPolicy: string = '';

  AllowVolumeExpansion: boolean = false;
}
